// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_ResponderInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_ResponderInput — POST /chamados/responder.
 *
 * `interna` DEFAULT false, e é o default certo: errar para "público" mostra ao
 * franqueado uma mensagem que a franqueadora queria guardar; errar para
 * "interno" faz a resposta SUMIR para quem esperava por ela, e ninguém
 * descobre — o franqueado só acha que foi ignorado. Entre um constrangimento
 * visível e um silêncio invisível, o default protege contra o segundo.
 *
 * Só `Full` consegue mandar `interna = true`; para o solicitante o controller
 * força false, porque nota interna do próprio solicitante não significa nada.
 */
import { registerContract } from './validate'

export interface Chamados_ResponderInput {
chamado_id: number
corpo?: string
interna?: boolean
}

registerContract('Chamados_ResponderInput', {
  chamado_id: { type: 'number',  required: true },
  corpo:      { type: 'string',  required: false },
  interna:    { type: 'boolean', required: false },
})
